var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"amount--label text-uppercase"},[_vm._t("default")],2),_vm._v(" "),_c('p',{staticClass:"amount--value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }